//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// custom pages
import config from "config/index";
import HandleApiResponse from "helpers/handleApiResponse";

function manageServicePlusAccountsAPI() {
  const { handleResponse, handleError } = HandleApiResponse();

  async function getAPI(values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/manage-signature-accounts/service-plus?query=${query}`,
        obj
      );

      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function searchAPI(values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/manage-signature-accounts/search-service?query=${query}`,
        obj
      );

      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function updateServiceAPI(values) {
    try {
      const obj = {
        method: "PUT",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/manage-signature-accounts/service-update`, obj);
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function courtesyPointsCalculation(values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/manage-signature-accounts/courtesy-points-calculation?query=${query}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function bulkSignatureUnEnroll(values) {
    try {
      const obj = {
        method: "PATCH",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values)
      };
      let res = await fetch(
        `${config.host}/cdr-panel/manage-signature-accounts/bulk-un-enroll`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function exportAPI(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/manage-signature-accounts/service-export`, obj);

      return handleResponse(res);

    } catch (err) {
      handleError(err);

    }
  }
  
  return {
    getAPI,
    searchAPI,
    updateServiceAPI,
    courtesyPointsCalculation,
    bulkSignatureUnEnroll,
    exportAPI
  };
}

export default manageServicePlusAccountsAPI;
